import React from 'react';

import classes from './Card.module.scss';

class Card extends React.Component<any, any> {
    render() {
      return <div className={`${classes.card} ${this.props.className}`}>{this.props.children}</div>;
    }
  }

export default Card;
